<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formSalesRemission">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()">
              </app-custom-button>
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteSalesRemission()">
              </app-custom-button>
              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewSalesRemission()"></app-custom-button>
              <app-custom-modal #orderSelection [inputs$]="inputsForOrdersSelection$"
                [children]="componentTableSelection" [output$]="output$" [label]="'Seleccionar'"
                [header]="'Selección de Pedidos'" hidden (selectedItems)="handleSelectedItem($event)">
              </app-custom-modal>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="salesRemissionContract.userNameCreate"
                [createDate]="salesRemissionContract.createDate"
                [userNameUpdate]="salesRemissionContract.userNameUpdate"
                [updateDate]="salesRemissionContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-lg-7 col-md-12 col-sm-12 col-12 pe-lg-5 pe-md-2">
              <div class="row">
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                  <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventory"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeInventory($event)">
                  </app-custom-select>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event, false)">
                  </app-custom-select>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-12">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                @if (!swOrderModule) {
                <div class="col-lg-9 col-md-9 col-sm-9 col-12">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClient"
                    [required]="true" (onChangeSelect)="getClient($event)">
                  </app-custom-autocomplete>
                </div>
                } @else {
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                  <app-custom-input-text [value]="codeNameClient" [labelText]="'Cliente'" [disabled]="true"
                    [required]="true">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                  <app-custom-input-text [value]="codeNameCostCenter" [labelText]="'C.Costos'" [disabled]="true"
                    [required]="true">
                  </app-custom-input-text>
                </div>
                }
                <div [class]="!swOrderModule ? 'col-lg-3 col-md-3 col-sm-3 col-6' : 'col-lg-2 col-md-2 col-sm-2 col-6'">
                  <app-custom-datepicker formControlName="dateOutput" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                  <app-custom-autocomplete formControlName="transporterId" [labelText]="'Transportador'"
                    [list]="listTransporters">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                  <app-custom-autocomplete formControlName="vehicleId" [labelText]="'Vehículo'" [list]="listVehicles">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-12">
                  <app-custom-input-decimal formControlName="transportValue" [labelText]="'Vr.Tansp.'">
                  </app-custom-input-decimal>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12 col-12 ps-lg-5 ps-md-2 pt-lg-0 pt-sm-2">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-3 col-md-2 col-sm-3 col-4 d-flex align-items-end gap-2 mt-2">
                  <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeState()"></app-custom-button>
                  <app-custom-checkbox formControlName="swBlock" class="mt-1" [labelText]="'Bloq.'"
                    (onChangeCheckBox)="blockSalesRemission($event)"></app-custom-checkbox>
                </div>
                <div class="col-lg-5 col-md-4 col-sm-5 col-8 d-flex align-items-end gap-2 justify-content-start">
                  <app-custom-chip [label]="'Nro.Pedido: ' + orderConsecutive" />
                  <app-custom-chip [label]="'Nro.Factura: ' + invoiceConsecutive" />
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                    [rows]="1" [maxLength]="250"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-3">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-sales-remission-detail [disabledDetail]="disabledDetail" [salesRemissionModel]="salesRemissionContract"
      [quantityDetails]="quantityDetails" [permissionUpdatable]="permissionUpdatable" [swOrderModule]="swOrderModule"
      (hasQuantityInZero)="hasQuantityInZero = $event" (emitQuantityDetails)="quantityDetails = $event">
    </app-sales-remission-detail>
  </div>
</section>

<!-- Impresión -->
<app-print-sales-remission id="print-sales-remission" [formatModel]="formatModel"
  [salesRemissionPrintModel]="salesRemissionPrintModel" [focusText]="true" [editFormat]="false"
  (finishLoadingPrint)="finishLoading($event)"></app-print-sales-remission>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{ nameWindow }} abiertas.</h6>
</div>